import { Card, CardContent, Typography } from '@mui/material';
import tokens from '../styles/tokens';
import React from 'react';

const NumberDisplayCard = ({color, count, infoText, variant='h2'}) => {
    return (
        <Card
            sx={{
                minWidth: 220,
                maxWidth: 360,
                margin: tokens.spacing.cardMargin,
                borderRadius: tokens.radius.md,
                border: `1px solid ${tokens.colors.border}`,
                background: tokens.colors.surface,
                boxShadow: tokens.colors.shadow
            }}
            elevation={0}
        >
            <CardContent sx={{ py: 2.5, px: 3 }}>
                <Typography variant={variant} color={color} align='center' sx={{ fontWeight: 700, lineHeight: 1 }}>
                    {count}
                </Typography>
                <Typography align='center' sx={{ color: tokens.colors.textMuted, mt: 1, fontWeight: 500 }}>
                    {infoText}
                </Typography>
            </CardContent>
        </Card>
    );
}

export default NumberDisplayCard;
